import { PhoneBase } from '../../../catalog/products/equipement/complex/phone';
import { PlanBase } from '../../../catalog/products/subscription/plan';

/**
 * Created by fruysshaert on 11/07/2017.
 */
import { RulesBase } from './rules.class';

export class RulesRenewBase extends RulesBase {
    public KEY: string = 'renewPremium';

    public isValid(): string[] {
        const errors: string[] = [];
        if (!this.scheme.getProductsByType(PhoneBase).length) {
            errors.push('Vous devez avoir un terminal au panier, veuillez scanner un terminal');
        }
        if (!this.scheme.getProductsByType(PlanBase).length) {
            errors.push('Vous devez avoir un forfait au panier, veuillez scanner un terminal');
        }
        return errors;
    }
}
